module.exports = __webpack_public_path__ + "static/media/shutterstock_1005938026-scaled.fae75d7d.jpg";